import { ReactNode } from 'react'
import Header from '@/components/Header'
import { Images } from '@/assets/Images'

interface GameLayoutProps {
  children: ReactNode
  backgroundColor?: string
}

const GameLayout = ({ children, backgroundColor = 'bg-white' }: GameLayoutProps) => {
  return (
    <div
      className={`flex flex-col w-full min-h-screen overflow-y-auto ${backgroundColor}`}
      style={{
        backgroundImage: `url(${Images.background_paper})`,
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        backgroundAttachment: 'fixed',
      }}
    >
      {/* Header with Notification Bell and Avatar */}
      <Header />

      <div className="md:px-0 w-full px-4 min-h-[calc(100vh-76px)]">{children}</div>
    </div>
  )
}

export default GameLayout
